import { useQuery } from '@tanstack/react-query';
import { type GetLADClaimFilesRequestParams, fetchLADClaimFiles } from '../data-provider/lad-claim-files/api';

export const useGetLADClaimFiles = (params: Partial<GetLADClaimFilesRequestParams>) => {
  return useQuery({
    queryKey: ['claims-loss-and-damage-files', params.ClaimKey],
    queryFn: () => fetchLADClaimFiles(params as GetLADClaimFilesRequestParams),
    enabled: !!params.ClaimKey,
  });
};
